// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseBar_root__nLovG","rotation":"CloseBar_rotation__IGv44"};